module.exports = __webpack_public_path__ + "static/media/bm-ortofoto2009.319d84e9.png";